import { motion } from "motion/react";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

const Header = ({ eventHandler }) => {

    const navigation = (text) => {
        let navHeigth = document.getElementById('navbar').offsetHeight;
        return eventHandler(text, navHeigth);
    }

    return (
        <motion.div
            className="container-fluid border-bottom shadow-lg fixed-top bg-light border-bottom"
            style={{ zIndex: 99 }}
            id="navbar"
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, easing: "ease-out" }}
        >
            <div className="container">
                <div className="row p-3">
                    <div className="col-md-6 d-flex align-items-center justify-content-center">
                        <motion.img
                            src="/img/logosafibc.png"
                            alt=""
                            className="logo"
                            width={'125px'}
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3, duration: 0.5, easing: "ease-out" }} />
                    </div>

                    <div className="col-md-6 d-flex align-items-center justify-content-center" id="menu">
                        {["Inicio", "Acerca de", "Ahorros", "Trayectoria", "Contacto", "Simulador",].map((item, index) => (
                            <motion.div
                                key={item}
                                className="d-flex align-items-center"
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.5 + index * 0.1, duration: 0.4, easing: "ease-out" }}
                            >
                                {item === "Simulador" ? (
                                    <>
                                        <motion.button
                                            onClick={() => navigation(item.toLowerCase().replace(/\s+/g, ''))}
                                            className="fw-bold px-4 py-2"
                                            style={{
                                                backgroundColor: "#025A8C",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "25px",
                                                fontSize: "16px",
                                                cursor: "pointer",
                                                boxShadow: "0px 4px 6px rgba(0,0,0,0.2)",
                                            }}
                                            animate={{
                                                y: [0, -5, 0], // efecto de subir y bajar
                                                boxShadow: ["0px 4px 6px rgba(0,0,0,0.2)", "0px 8px 12px rgba(0,0,0,0.3)", "0px 4px 6px rgba(0,0,0,0.2)"]
                                            }}
                                            transition={{
                                                duration: 1.5,
                                                repeat: Infinity,
                                                repeatType: "loop",
                                                ease: "easeInOut"
                                            }}
                                        >
                                            <CurrencyExchangeIcon /> &nbsp; 
                                            {item}
                                        </motion.button>
                                        {index < 4 && <div className="vertical-line mx-2"></div>}
                                    </>
                                ) : (
                                    <>
                                        <span
                                            className="fw-bold pmenu px-2"
                                            onClick={() => navigation(item.toLowerCase().replace(/\s+/g, ''))}
                                        >
                                            {item}
                                        </span>
                                        {index < 4 && <div className="vertical-line mx-2"></div>}
                                    </>
                                )}
                            </motion.div>
                        ))}


                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default Header;


